import React, { createContext, ReactElement, useEffect, useState } from 'react';
import { useSiteContext } from '@zooplus/commons-lang';
import { CentralHubService } from '../../services/CentralHubService';

export interface AutoshipmentSiteContextProps {
  preponeDays: number;
  deliveryMinDays: number;
  deliveryMaxDays: number;
  isRelaxDelivery: boolean;
}

const AutoshipmentSiteContext = createContext<Partial<AutoshipmentSiteContextProps>>({});

export interface AutoshipmentSiteProviderProps {
  children?: React.ReactNode;
}

export const AutoshipmentSiteProvider: React.FC<AutoshipmentSiteProviderProps> = ({
  children,
}): ReactElement => {
  const { site } = useSiteContext();

  const [isRelaxDelivery, setIsRelaxDelivery] = useState<boolean>(false);
  const [preponeDays, setPreponeDays] = useState<number | undefined>(undefined);
  const [deliveryMinDays, setDeliveryMinDays] = useState<number | undefined>(undefined);
  const [deliveryMaxDays, setDeliveryMaxDays] = useState<number | undefined>(undefined);

  useEffect(() => {
    CentralHubService(undefined)
      .getSiteConfig(site.domain)
      .then((response) => {
        if (response.orderProcessing) {
          setPreponeDays(response.orderProcessing.preponeDays);
          setDeliveryMinDays(response.orderProcessing.deliveryMinDays);
          setDeliveryMaxDays(response.orderProcessing.deliveryMaxDays);
          setIsRelaxDelivery(Boolean(response.orderProcessing.preponeDays));
        }
      });
  }, []);

  return (
    <React.StrictMode>
      <AutoshipmentSiteContext.Provider
        value={{
          preponeDays: preponeDays,
          deliveryMinDays: deliveryMinDays,
          deliveryMaxDays: deliveryMaxDays,
          isRelaxDelivery: isRelaxDelivery,
        }}>
        {children}
      </AutoshipmentSiteContext.Provider>
    </React.StrictMode>
  );
};

export default AutoshipmentSiteContext;
